import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "bg-[#23242A] text-white app-header custom p-3",
  id: "content_screen"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "custom-full customer-list" }
const _hoisted_4 = { class: "bg-[#2B2C32] rounded-lg max-w-full" }
const _hoisted_5 = {
  key: 0,
  class: "w-full hidden-component custom-right"
}
const _hoisted_6 = {
  key: 1,
  class: "flex lg:flex-row flex-col bg-[#2B2C32] rounded-xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.vg_selectedLocation.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass('px-3 pt-3 flex content-main ' + (_ctx.action.component ? ' half-it gap-5' : 'gap-5'))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_List, {
                  changeComponent: _ctx.addUpdate,
                  selectedCallback: _ctx.selectedItem,
                  clearComponent: _ctx.clearComponent,
                  iscomponentactive: _ctx.action.component ? true : false
                }, null, 8, ["changeComponent", "selectedCallback", "clearComponent", "iscomponentactive"])
              ])
            ]),
            (_ctx.action.component)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.action.component), {
                    item: _ctx.action.data,
                    clearComponent: _ctx.clearComponent
                  }, null, 8, ["item", "clearComponent"]))
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "w-full" }, [
            _createElementVNode("div", { class: "bg-[#2B2C32] rounded-lg px-8 py-[16px]" }, [
              _createElementVNode("p", { class: "text-center text-theme-red" }, "Please select a location from the top left corner.")
            ])
          ], -1)
        ]))]))
  ]))
}